export default {
	title: 'Stakes',
	url: 'stakes',
	subtitle:
		'List the fundamental parameters that qualify the « what » and « how », for example values, principles, short vision or strategic slogan. Note that you can weigh them.',
	no_description: 'No defined goal',
	context_worse: 'Negative',
	context_best: 'Positive'
};
